
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartGridIec as ObiChartGridIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-grid-iec.js';
 
 
 

 
 export const ObiChartGridIec = createComponent({
   react: React,
   tagName: 'obi-chart-grid-iec',
   elementClass: ObiChartGridIecElement,
   events: {
     
   }
  });
 
 